import React from "react";
import {
  RUN_MODE_QUEUE,
  RUN_MODE_HOLD,
  RUN_MODE_NOW,
  QUEUE_HOLD_TITLE,
  RUN_TITLE,
} from "./rsaRunDispatch";

/**
 * The run actions of a project analysis form (summary footer and the
 * multi-route panel share it). Owner's model, 2026-09-08 evening:
 *
 *   queueRunEnabled (rsa-existing):
 *     "Run"                     → onRun(e, "queue")  enqueue; starts automatically
 *     "Queue"  (canHold only)   → onRun(e, "hold")   enqueue HELD; an admin starts
 *                                                    it from Multi-project runs
 *   !queueRunEnabled (rsa-model — the queue does not admit it):
 *     "Run Analysis"            → onRun(e, "now")    (unchanged direct button)
 *
 * `canHold` is the admin flag (canSeeWholeQueue); non-admins never see "Queue".
 * The "Queue" button reuses the primary button's class (same visual size) plus
 * a `--hold` modifier for its colour. There is deliberately no "Run now" bypass
 * for rsa-existing.
 */
function RunActionButtons({
  queueRunEnabled = true,
  canHold = false,
  inProgress = false,
  disabled = false,
  onRun,
  primaryLabel = "Run",
  holdLabel = "Queue",
  busyLabel = "Queuing...",
  directLabel = "Run Analysis",
  directBusyLabel = "Running...",
  primaryClassName = "toggle-btn-rsa-run",
  children = null,
}) {
  const blocked = inProgress || disabled;
  const fire = (mode) => (e) => {
    if (onRun) onRun(e, mode);
  };
  return (
    <>
      <button
        className={`${primaryClassName}${inProgress ? ` ${primaryClassName}--loading` : ""}`}
        type="button"
        onClick={fire(queueRunEnabled ? RUN_MODE_QUEUE : RUN_MODE_NOW)}
        disabled={blocked}
        title={queueRunEnabled ? RUN_TITLE : "Run analysis now"}
        data-testid="rsa-run-primary"
      >
        {inProgress ? (
          <>
            <i className="fas fa-spinner fa-spin" aria-hidden />{" "}
            {queueRunEnabled ? busyLabel : directBusyLabel}
          </>
        ) : queueRunEnabled ? (
          primaryLabel
        ) : (
          directLabel
        )}
      </button>
      {queueRunEnabled && canHold && (
        <button
          className={`${primaryClassName} ${primaryClassName}--hold`}
          type="button"
          onClick={fire(RUN_MODE_HOLD)}
          disabled={blocked}
          title={QUEUE_HOLD_TITLE}
          data-testid="rsa-run-hold"
        >
          <i className="fa-solid fa-layer-group" aria-hidden /> {holdLabel}
        </button>
      )}
      {children}
    </>
  );
}

export default RunActionButtons;
